import React, { createContext, useState, useContext, useEffect } from 'react';

const ManagerAuthContext = createContext(null);

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4002';
const STORAGE_KEY = 'bpv_manager_auth';

export const ManagerAuthProvider = ({ children }) => {
  const [manager, setManager] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      try {
        const { token: t, staff } = JSON.parse(saved);
        // Verify token not expired by checking payload
        const payload = JSON.parse(atob(t.split('.')[1]));
        if (payload.exp * 1000 > Date.now()) {
          setToken(t);
          setManager(staff);
        } else {
          localStorage.removeItem(STORAGE_KEY);
        }
      } catch (_) {
        localStorage.removeItem(STORAGE_KEY);
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const res = await fetch(`${API_URL}/api/manager/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    const result = await res.json();
    if (!result.success) throw new Error(result.message);
    setToken(result.token);
    setManager(result.staff);
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ token: result.token, staff: result.staff }));
    return result.staff;
  };

  const logout = () => {
    setToken(null);
    setManager(null);
    localStorage.removeItem(STORAGE_KEY);
  };

  const getToken = () => token;

  return (
    <ManagerAuthContext.Provider value={{ manager, token, loading, login, logout, getToken }}>
      {children}
    </ManagerAuthContext.Provider>
  );
};

export const useManagerAuth = () => {
  const ctx = useContext(ManagerAuthContext);
  if (!ctx) throw new Error('useManagerAuth must be used within ManagerAuthProvider');
  return ctx;
};

export default ManagerAuthContext;
